import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetTutorQuery = () => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useQuery({
    queryKey: "gettutor",
    queryFn: async () => {
      if (!token) {
        throw new Error("Token not found");
      }

      const response = await axiosInstance.get("/tutors/me", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error fetching user data:", error);
    },
  });
};
